export default "__VITE_ASSET__BvkVvfVZ__"